@if (visible && departmentOptions.length) {
  <div class="ptw-notices" aria-live="polite">
    @for (notice of notices; track notice.permitId) {
      <a
        class="ptw-notice"
        [class.ptw-notice-progress]="notice.state === permitState.InProgress"
        [attr.href]="canReadCounters ? '/permit-to-work/' + notice.permitId : null"
        (click)="openPermit(notice, $event)"
      >
        <span class="ptw-notice-label">
          <mat-icon>
            {{ notice.state === permitState.InProgress ? 'sync' : 'warning_amber' }}
          </mat-icon>
          {{
            (notice.state === permitState.InProgress
              ? 'ptw.dashboard.workInProgress'
              : 'ptw.dashboard.upcomingWork'
            ) | translate
          }}
        </span>
        <h3>{{ notice.name }}</h3>
        <div class="ptw-notice-details">
          <span>
            <mat-icon>sell</mat-icon>
            {{ 'type' | translate }}:
            <strong>{{ notice.type.name }}</strong>
          </span>
          <span>
            <mat-icon>location_on</mat-icon>
            {{ 'location' | translate }}:
            <strong>
              {{ notice.locationType.name }}
              @if (notice.specificLocation) {
                · {{ notice.specificLocation }}
              }
            </strong>
          </span>
          <span>
            <mat-icon>schedule</mat-icon>
            {{
              (notice.state === permitState.InProgress
                ? 'ptw.dashboard.started'
                : 'ptw.dashboard.starts'
              ) | translate
            }}:
            <strong>{{ notice.start | date: 'd MMM y, HH:mm' }}</strong>
          </span>
          <span>
            {{ 'ptw.dashboard.ends' | translate }}:
            <strong>{{ notice.end | date: 'd MMM y, HH:mm' }}</strong>
          </span>
        </div>
      </a>
    }
  </div>
  @if (canReadCounters) {
    <section class="ptw-dashboard" [attr.aria-label]="'permitToWork' | translate">
      <header>
        <h2>{{ 'permitToWork' | translate }}</h2>
        <app-ui-select
          [label]="'departmentSelector' | translate"
          [control]="departmentControl"
          [options]="departmentOptions"
          [isMultiple]="false"
          [enableSearch]="true"
          [compactOnMobile]="true"
          triggerPrefix="department"
          panelClass="dashboard-department-select-panel"
        ></app-ui-select>
      </header>
      @if (countersFailed || noticesFailed) {
        <div class="ptw-dashboard-error" role="alert">
          <span>
            {{
              (countersFailed ? 'ptw.dashboard.countersFailed' : 'ptw.dashboard.noticesFailed')
                | translate
            }}
          </span>
          <app-ui-button
            buttonType="secondary"
            icon="refresh"
            [text]="'ptw.dashboard.retry' | translate"
            (click)="retry()"
          ></app-ui-button>
        </div>
      }
      <div class="ptw-counter-row">
        <app-ui-widget-card
          class="paired"
          [blocks]="forApproval"
          [loading]="loading"
        ></app-ui-widget-card>
        <app-ui-widget-card
          name="ptw.dashboard.myRejected"
          [value]="rejected"
          icon="error_outline"
          iconColor="red"
          [loading]="loading"
        ></app-ui-widget-card>
        <app-ui-widget-card
          class="paired"
          [blocks]="approved"
          [loading]="loading"
        ></app-ui-widget-card>
        <app-ui-widget-card
          name="ptw.dashboard.allFinished"
          [value]="finished"
          icon="done_all"
          iconColor="green"
          [loading]="loading"
        ></app-ui-widget-card>
      </div>
      <h3 class="ptw-progress-title">{{ 'ptw.state.InProgress' | translate }}</h3>
      <div class="ptw-progress-row">
        @for (bucket of progress; track bucket.key) {
          <app-ui-widget-card [blocks]="bucket.blocks" [loading]="loading"></app-ui-widget-card>
        }
      </div>
    </section>
  } @else if (noticesFailed) {
    <div class="ptw-dashboard-error" role="alert">
      <span>{{ 'ptw.dashboard.noticesFailed' | translate }}</span>
      <app-ui-button
        buttonType="secondary"
        icon="refresh"
        [text]="'ptw.dashboard.retry' | translate"
        (click)="retry()"
      ></app-ui-button>
    </div>
  }
}
